module.exports = __webpack_public_path__ + "images/155099724c737c379b6ae35c3b800db266cfa8de86a4fc7fce1e2c00994b76b5.svg";